
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93TiTRYnnSVPMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/[...slug].vue?macro=true";
import { default as _91slug_93EMHMvMwDBXMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/[slug].vue?macro=true";
import { default as indexJNRkvrnY1bMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/index.vue?macro=true";
import { default as _91slug_93qLi7Mz023HMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/[slug].vue?macro=true";
import { default as indexyYUioMLRuuMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/index.vue?macro=true";
import { default as index4CPt2amHY9Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/index.vue?macro=true";
import { default as medewerkersC9jFReX8JzMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/medewerkers.vue?macro=true";
import { default as _91slug_93KM046fk3IgMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/[slug].vue?macro=true";
import { default as indexB9JOVhX14XMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/index.vue?macro=true";
import { default as _91slug_936oRnjlTnV8Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/[slug].vue?macro=true";
import { default as indextO3oOWfQHqMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/index.vue?macro=true";
import { default as _91slug_93k3VeeKfnyBMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/vacancies/[slug].vue?macro=true";
import { default as _91slug_93hGr1WNDWF5Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/[slug].vue?macro=true";
import { default as indexmUBhVoxW8GMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/index.vue?macro=true";
import { default as indexliNWjn73f9Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/index.vue?macro=true";
import { default as contactw1I2pM3NVOMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/contact.vue?macro=true";
import { default as _91slug_93fFokF8841qMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/[slug].vue?macro=true";
import { default as indexiSXLgrmnR0Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/index.vue?macro=true";
import { default as index7OIgUsqPdLMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/index.vue?macro=true";
import { default as _91slug_93elA1NaufniMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/[slug].vue?macro=true";
import { default as indexoDKRv4ku2gMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/index.vue?macro=true";
import { default as _91slug_932jpPVcprdBMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/[slug].vue?macro=true";
import { default as indexO5fljcmaIiMeta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/index.vue?macro=true";
import { default as search1gvnrmdkW0Meta } from "/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/search.vue?macro=true";
export default [
  {
    name: "slug___nl",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93TiTRYnnSVPMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93TiTRYnnSVPMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "slug___de",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93TiTRYnnSVPMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/[...slug].vue")
  },
  {
    name: "about-us-business-councils-slug___nl",
    path: "/over-ons/business-councils/:slug()",
    meta: _91slug_93EMHMvMwDBXMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils-slug___en",
    path: "/about-us/business-councils/:slug()",
    meta: _91slug_93EMHMvMwDBXMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils-slug___de",
    path: "/uber-uns/unternehmensrate/:slug()",
    meta: _91slug_93EMHMvMwDBXMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/[slug].vue")
  },
  {
    name: "about-us-business-councils___nl",
    path: "/over-ons/business-councils",
    meta: indexJNRkvrnY1bMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-business-councils___en",
    path: "/about-us/business-councils",
    meta: indexJNRkvrnY1bMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-business-councils___de",
    path: "/uber-uns/unternehmensrate",
    meta: indexJNRkvrnY1bMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/business-councils/index.vue")
  },
  {
    name: "about-us-committees-slug___nl",
    path: "/over-ons/comites/:slug()",
    meta: _91slug_93qLi7Mz023HMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees-slug___en",
    path: "/about-us/committees/:slug()",
    meta: _91slug_93qLi7Mz023HMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees-slug___de",
    path: "/uber-uns/aussch%C3%BCsse/:slug()",
    meta: _91slug_93qLi7Mz023HMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/[slug].vue")
  },
  {
    name: "about-us-committees___nl",
    path: "/over-ons/comites",
    meta: indexyYUioMLRuuMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us-committees___en",
    path: "/about-us/committees",
    meta: indexyYUioMLRuuMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us-committees___de",
    path: "/uber-uns/aussch%C3%BCsse",
    meta: indexyYUioMLRuuMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/committees/index.vue")
  },
  {
    name: "about-us___nl",
    path: "/over-ons",
    meta: index4CPt2amHY9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us___en",
    path: "/about-us",
    meta: index4CPt2amHY9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us___de",
    path: "/uber-uns",
    meta: index4CPt2amHY9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/index.vue")
  },
  {
    name: "about-us-medewerkers___nl",
    path: "/over-ons/medewerkers",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-medewerkers___en",
    path: "/about-us/employees",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-medewerkers___de",
    path: "/uber-uns/personal",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/medewerkers.vue")
  },
  {
    name: "about-us-networking-clubs-slug___nl",
    path: "/over-ons/netwerkclubs/:slug()",
    meta: _91slug_93KM046fk3IgMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs-slug___en",
    path: "/about-us/networking-clubs/:slug()",
    meta: _91slug_93KM046fk3IgMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs-slug___de",
    path: "/uber-uns/networking-clubs/:slug()",
    meta: _91slug_93KM046fk3IgMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/[slug].vue")
  },
  {
    name: "about-us-networking-clubs___nl",
    path: "/over-ons/netwerkclubs",
    meta: indexB9JOVhX14XMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-clubs___en",
    path: "/about-us/networking-clubs",
    meta: indexB9JOVhX14XMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-clubs___de",
    path: "/uber-uns/networking-clubs",
    meta: indexB9JOVhX14XMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-clubs/index.vue")
  },
  {
    name: "about-us-networking-groups-slug___nl",
    path: "/over-ons/netwerkgroepen/:slug()",
    meta: _91slug_936oRnjlTnV8Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups-slug___en",
    path: "/about-us/networking-groups/:slug()",
    meta: _91slug_936oRnjlTnV8Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups-slug___de",
    path: "/uber-uns/netzwerkgruppen/:slug()",
    meta: _91slug_936oRnjlTnV8Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/[slug].vue")
  },
  {
    name: "about-us-networking-groups___nl",
    path: "/over-ons/netwerkgroepen",
    meta: indextO3oOWfQHqMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-networking-groups___en",
    path: "/about-us/networking-groups",
    meta: indextO3oOWfQHqMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-networking-groups___de",
    path: "/uber-uns/netzwerkgruppen",
    meta: indextO3oOWfQHqMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/networking-groups/index.vue")
  },
  {
    name: "about-us-vacancies-slug___nl",
    path: "/over-ons/vacatures/:slug()",
    meta: _91slug_93k3VeeKfnyBMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "about-us-vacancies-slug___en",
    path: "/about-us/vacancies/:slug()",
    meta: _91slug_93k3VeeKfnyBMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "about-us-vacancies-slug___de",
    path: "/uber-uns/Stellenangebote/:slug()",
    meta: _91slug_93k3VeeKfnyBMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/about-us/vacancies/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___nl",
    path: "/ambities/:ambition()/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___en",
    path: "/ambitions/:ambition()/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition-slug___de",
    path: "/ambitionen/:ambition()/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/[slug].vue")
  },
  {
    name: "ambitions-ambition___nl",
    path: "/ambities/:ambition()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions-ambition___en",
    path: "/ambitions/:ambition()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions-ambition___de",
    path: "/ambitionen/:ambition()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/[ambition]/index.vue")
  },
  {
    name: "ambitions___nl",
    path: "/ambities",
    meta: indexliNWjn73f9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "ambitions___en",
    path: "/ambitions",
    meta: indexliNWjn73f9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "ambitions___de",
    path: "/ambitionen",
    meta: indexliNWjn73f9Meta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/ambitions/index.vue")
  },
  {
    name: "contact___nl",
    path: "/contact",
    meta: contactw1I2pM3NVOMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/contact.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    meta: contactw1I2pM3NVOMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/contact.vue")
  },
  {
    name: "contact___de",
    path: "/kontakt",
    meta: contactw1I2pM3NVOMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/contact.vue")
  },
  {
    name: "events-slug___nl",
    path: "/agenda/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events-slug___en",
    path: "/events/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events-slug___de",
    path: "/veranstaltungen/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/[slug].vue")
  },
  {
    name: "events___nl",
    path: "/agenda",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/index.vue")
  },
  {
    name: "events___en",
    path: "/events",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/index.vue")
  },
  {
    name: "events___de",
    path: "/ereignisse",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/events/index.vue")
  },
  {
    name: "index___nl",
    path: "/",
    meta: index7OIgUsqPdLMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: index7OIgUsqPdLMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/",
    meta: index7OIgUsqPdLMeta || {},
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/index.vue")
  },
  {
    name: "members-slug___nl",
    path: "/leden/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members-slug___en",
    path: "/members/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members-slug___de",
    path: "/mitglieder/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/[slug].vue")
  },
  {
    name: "members___nl",
    path: "/leden",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/index.vue")
  },
  {
    name: "members___en",
    path: "/members",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/index.vue")
  },
  {
    name: "members___de",
    path: "/mitglieder",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/members/index.vue")
  },
  {
    name: "news-slug___nl",
    path: "/nieuws/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news-slug___en",
    path: "/news/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news-slug___de",
    path: "/nachrichten/:slug()",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/[slug].vue")
  },
  {
    name: "news___nl",
    path: "/nieuws",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/index.vue")
  },
  {
    name: "news___en",
    path: "/news",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/index.vue")
  },
  {
    name: "news___de",
    path: "/nachrichten",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/news/index.vue")
  },
  {
    name: "search___nl",
    path: "/zoeken",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/search.vue")
  },
  {
    name: "search___en",
    path: "/search",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/search.vue")
  },
  {
    name: "search___de",
    path: "/s%C3%BCchen",
    component: () => import("/data/www/groentenfruithuis.nl/gfh/nuxt/website/pages/search.vue")
  }
]